import { render, staticRenderFns } from "./uploadimg.vue?vue&type=template&id=63b39d9c&scoped=true&"
import script from "./uploadimg.vue?vue&type=script&lang=js&"
export * from "./uploadimg.vue?vue&type=script&lang=js&"
import style0 from "./uploadimg.vue?vue&type=style&index=0&id=63b39d9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b39d9c",
  null
  
)

export default component.exports